import BaseComponent from "@js/components/base_component.jsx";

import MuiAlertsIndexTable from "@js/components/mui/alerts/index_table.jsx";

class MuiAlertsIndex extends BaseComponent {

  render() {
    const table = this.props.alerts;

    return (
      <div>
        <Panel heading="alerts">
          <MuiAlertsIndexTable
            alerts={ table && table.data }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>
      </div>
    );
  }

}

export default MuiAlertsIndex;
